import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import classes from "./EventCard.module.css";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/uz-latn";
import announcementImg from "../../../opener/assets/imgs/bg-img.png"; // Default image

const stripHtml = (html) => {
    if (!html) return "";
    try {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
    } catch {
        return String(html).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    }
};

const EventCard = ({ extraCurricular, index }) => {
    const { i18n, t } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const [needsToggle, setNeedsToggle] = useState(false);
    const descRef = useRef(null);

    moment.locale(i18n.language || "uz-latn");

    const title = extraCurricular[`title_${i18n.language}`] || extraCurricular.title_uz;

    const short = extraCurricular[`short_announcement_${i18n.language}`] || extraCurricular.short_announcement_uz;
    const full = extraCurricular[`full_announcement_${i18n.language}`] || extraCurricular.full_announcement_uz;
    const description = stripHtml(short && short.trim().length > 0 ? short : full);

    useEffect(() => {
        if (expanded) return; // measure only when clamped
        const el = descRef.current;
        if (!el) return;
        // Wait for layout
        const raf = requestAnimationFrame(() => {
            try {
                const needs = el.scrollHeight > el.clientHeight + 1;
                setNeedsToggle(needs);
            } catch { }
        });
        return () => cancelAnimationFrame(raf);
    }, [description, expanded, i18n.language]);

    return (
        <Link
            to={`/announce/${extraCurricular.id}`}
            className={classes.cardLink}
            data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
        >
            <div className={classes.eventCard}>
                <img
                    src={extraCurricular.image || announcementImg}
                    alt={title}
                    className={classes.cardImage}
                />
                <div className={classes.cardContent}>
                    <p className={classes.cardDate}>
                        {moment(extraCurricular.finishing_time).format("DD.MM.YYYY")}
                    </p>
                    <h3 className={classes.cardTitle}>{title}</h3>
                    <p
                        ref={descRef}
                        className={`${classes.cardDescription} ${classes.clamped}`}
                    >
                        {description}
                    </p>
                    <span className={classes.seeMore}>
                        {t("Ko'proq ko'rish")}
                    </span>
                </div>
            </div>
        </Link>
    );
};

export default EventCard;
